import { motion } from "framer-motion";
import { Eye, Sparkles, TrendingUp, ArrowUpRight } from "lucide-react";

const cards = [
    {
        icon: Eye,
        title: "Meer zichtbaarheid",
        desc: "Video presteert beter dan statische beelden op social media zoals Instagram, TikTok en Facebook.",
    },
    {
        icon: Sparkles,
        title: "Sterkere eerste indruk",
        desc: "Een cinematische presentatie geeft jouw panden een professionelere uitstraling.",
    },
    {
        icon: TrendingUp,
        title: "Meer aandacht per pand",
        desc: "Bewegend beeld trekt sneller de aandacht van potentiële kopers of huurders.",
    },
];

export const WhyItWorks = () => {
    return (
        <section
            id="why"
            data-testid="why-section"
            className="relative py-20 md:py-28 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="max-w-3xl mb-16 md:mb-20"
                >
                    <p className="text-[11px] font-bold tracking-[0.3em] uppercase text-neutral-500 mb-5">
                        / 01 — Waarom video werkt
                    </p>
                    <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-black leading-[1.02]">
                        Foto's tonen een pand.{" "}
                        <span className="italic font-light text-neutral-400">
                            Video's verkopen het.
                        </span>
                    </h2>
                </motion.div>

                <div className="grid md:grid-cols-3 gap-5">
                    {cards.map((c, i) => (
                        <motion.div
                            key={c.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            data-testid={`why-card-${i}`}
                            className="card-reveal group relative p-8 md:p-10 rounded-3xl bg-neutral-50 border border-black/5 transition-all duration-500 hover:bg-black hover:border-black hover:-translate-y-2 hover:shadow-[0_30px_60px_-20px_rgba(0,0,0,0.35)] cursor-default"
                        >
                            <div className="flex items-start justify-between mb-10">
                                <div className="flex items-center justify-center w-12 h-12 rounded-2xl bg-white border border-black/5 transition-colors">
                                    <c.icon className="w-5 h-5 text-black" />
                                </div>
                                <ArrowUpRight className="w-5 h-5 text-neutral-400 transition-all duration-500 group-hover:text-white group-hover:rotate-45" />
                            </div>

                            <h3 className="font-heading text-2xl md:text-3xl font-bold text-black group-hover:text-white tracking-tight mb-4 leading-tight transition-colors">
                                {c.title}
                            </h3>
                            <p className="text-neutral-600 group-hover:text-neutral-300 leading-relaxed transition-colors">
                                {c.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
